import React from "react";
import { useTranslation } from "react-i18next";
import { FiAtSign, FiCalendar, FiMail, FiUser } from "react-icons/fi";
import { Card } from "components/ui";
import AccountToggle from "./AccountToogle";
import DobToggle from "./DobToogle";
import GenderToggle from "./GenderToogle";
import { AccountEditButton, AccountSettingRow, accountValueInputClass } from "./AccountSettingRow";

interface AccountPersonalDetailsProps {
  item: any;
  username: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
  handleKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  isPopupOpenGender: boolean;
  setIsPopupOpenGender: (value: boolean) => void;
  toggleGenderpopup: () => void;
  isPopupOpenDob: boolean;
  setIsPopupOpenDob: (value: boolean) => void;
  toggleDobpopup: () => void;
  isPopupOpen: boolean;
  setIsPopupOpen: (value: boolean) => void;
  togglepopup: () => void;
}

/** "Personal details" card: gender, date of birth, email and username rows. */
export const AccountPersonalDetails = ({
  item,
  username,
  onInputChange,
  handleKeyDown,
  isPopupOpenGender,
  setIsPopupOpenGender,
  toggleGenderpopup,
  isPopupOpenDob,
  setIsPopupOpenDob,
  toggleDobpopup,
  isPopupOpen,
  setIsPopupOpen,
  togglepopup,
}: AccountPersonalDetailsProps) => {
  const { t } = useTranslation();

  return (
    <Card title="Personal details" subtitle="Basic information about you and your account." flush>
      <div className="divide-y divide-line">
        <AccountSettingRow
          icon={<FiUser />}
          label={<label className="mb-0">{t("Account.Label.Gender")}</label>}
          action={<AccountEditButton onClick={toggleGenderpopup} label={t("Account.Label.Gender")} />}
        >
          <input
            type=" text"
            className={`${accountValueInputClass} capitalize`}
            value={item.gender}
            placeholder="Set Your Gender"
            onChange={onInputChange}
            onKeyDown={handleKeyDown}
          />
          {isPopupOpenGender && (
            <div>
              <GenderToggle gender={item.gender} isPopupOpenGender={() => setIsPopupOpenGender(false)} />
            </div>
          )}
        </AccountSettingRow>

        <AccountSettingRow
          icon={<FiCalendar />}
          label={<label className="mb-0">{t("Account.label.Dob")}</label>}
          action={<AccountEditButton onClick={toggleDobpopup} label={t("Account.label.Dob")} />}
        >
          <input
            type=" text"
            className={accountValueInputClass}
            value={item.dob}
            placeholder="Set Your DOB"
            onChange={onInputChange}
            onKeyDown={handleKeyDown}
          />
          {isPopupOpenDob && (
            <div>
              <DobToggle dob={item.dob} isPopupOpenDob={() => setIsPopupOpenDob(false)} />
            </div>
          )}
        </AccountSettingRow>

        <AccountSettingRow
          icon={<FiMail />}
          label={<label className="mb-0">{t("Account.Label.Email")}</label>}
          description="The address you sign in with."
        >
          <input
            type="text"
            name="emailId"
            className={accountValueInputClass}
            placeholder="Steve.male@zamplia.com"
            onChange={onInputChange}
            value={item.user_email}
            onKeyDown={handleKeyDown}
          />
        </AccountSettingRow>

        <AccountSettingRow
          icon={<FiAtSign />}
          label={<label className="mb-0">{t("Account.Label.user_name")}</label>}
          action={<AccountEditButton onClick={togglepopup} label={t("Account.Label.user_name")} />}
        >
          <input
            type="text"
            className={accountValueInputClass}
            placeholder="stevemale57ki"
            onChange={onInputChange}
            value={item.user_nicename}
            onKeyDown={handleKeyDown}
          />
          {isPopupOpen && (
            <div>
              <AccountToggle username={username} isPopupOpen={() => setIsPopupOpen(false)} />
            </div>
          )}
        </AccountSettingRow>
      </div>
    </Card>
  );
};
